export const headers = [
  {
    headerName: 'Código de Marca',
    field: 'marca_id',
    sortable: true,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
    hide: true,
    suppressToolPanel: true,
  },
  {
    headerName: 'Marca',
    field: 'marca',
    sortable: true,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
  },
  {
    headerName: 'Código de Modelo',
    field: 'modelo_id',
    sortable: true,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
    hide: true,
    suppressToolPanel: true,
  },
  {
    headerName: 'Modelo',
    field: 'modelo',
    sortable: true,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
  },
  {
    headerName: 'Código Emisión de Co2',
    field: 'emision_co2_id',
    sortable: true,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
    hide: true,
    suppressToolPanel: true,
  },
  {
    headerName: 'Emisión de Co2',
    field: 'emision_co2',
    sortable: true,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
  },
];
